var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 16.5V14.8333C18.3333 13.2801 17.271 11.9751 15.8333 11.605M12.9166 1.7423C14.1382 2.23679 15 3.43443 15 4.83333C15 6.23224 14.1382 7.42988 12.9166 7.92437M14.1666 16.5C14.1666 14.9469 14.1666 14.1703 13.9129 13.5577C13.5746 12.741 12.9257 12.092 12.1089 11.7537C11.4963 11.5 10.7198 11.5 9.16663 11.5H6.66663C5.11349 11.5 4.33692 11.5 3.72435 11.7537C2.90759 12.092 2.25867 12.741 1.92036 13.5577C1.66663 14.1703 1.66663 14.9469 1.66663 16.5M11.25 4.83333C11.25 6.67428 9.75758 8.16667 7.91663 8.16667C6.07568 8.16667 4.58329 6.67428 4.58329 4.83333C4.58329 2.99238 6.07568 1.5 7.91663 1.5C9.75758 1.5 11.25 2.99238 11.25 4.83333Z",
    stroke: "#5C667B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtt);
export default __webpack_public_path__ + "static/media/att.e99e28779473fd33ce0a982e2497b499.svg";
export { ForwardRef as ReactComponent };